(function() {
    "use strict";
    angular.module("josdaviApp")
        .config(cfg);
    cfg.$inject = ["RestangularProvider"];

    function cfg(RestangularProvider) {
        RestangularProvider.setBaseUrl('/api');
    }
})();